import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },
  {
    path: '/disclaimer',
    name: 'Disclaimer',
    component: () => import(/* webpackChunkName: "disclaimer" */ '../views/Disclaimer.vue')
  },
  {
    path: '/message',
    name: 'MessageAdd',
    component: () => import(/* webpackChunkName: "message" */ '../views/MessageEdit.vue')
  },
  {
    path: '/message/edit/:id',
    name: 'MessageEdit',
    component: () => import(/* webpackChunkName: "message" */ '../views/MessageEdit.vue')
  },
  {
    path: '/message/view/:id',
    name: 'MessageView',
    component: () => import(/* webpackChunkName: "message" */ '../views/Message.vue')
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import(/* webpackChunkName: "search" */ '../views/Search.vue')
  },
  {
    path: '/search/category/:category',
    name: 'SearchByCategory',
    component: () => import(/* webpackChunkName: "search" */ '../views/Search.vue')
  },
  {
    path: '/search/user/:user',
    name: 'SearchByMember',
    component: () => import(/* webpackChunkName: "search" */ '../views/Search.vue')
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import(/* webpackChunkName: "settings" */ '../views/Settings.vue'),
  },
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "home" */ '../views/NotFound.vue'),
  }
]

const router = new VueRouter({
  base: process.env.VUE_APP_ROUTER_BASE_URL,
  mode: process.env.VUE_APP_ROUTER_MODE,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
